<div class="flex justify-end items-center mb-2">
  <div class="relative inline-block text-left">
    <button type="button"
            class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            (click)="toggleStatusMenu()"
            aria-haspopup="listbox"
            [attr.aria-expanded]="isStatusMenuOpen">
      {{ getStatusFilterLabel() }}
      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
        <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd"></path>
      </svg>
    </button>

    <div *ngIf="isStatusMenuOpen" class="absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
      <div class="py-1">
        <button type="button" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" (click)="selectStatusFilter(-1)">Alle</button>
        <button type="button" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" (click)="selectStatusFilter(1)">Aktiv</button>
        <button type="button" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" (click)="selectStatusFilter(0)">Inaktiv</button>
      </div>
    </div>
  </div>
</div>

<div class="mt-4 flow-root">
  <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <table class="relative min-w-full divide-y divide-gray-300">
        <thead>
          <tr>
            <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Nr.</th>
            <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Symbol</th>
            <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Name</th>
            <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Ort</th>
            <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Typ/Code</th>
            <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">SW</th>
            <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Einheit</th>
            <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
            <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
              <span class="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr *ngFor="let indicator of filtered; let i = index" class="hover:bg-gray-50" [ngClass]="{'bg-gray-50': i % 2 === 1}">
            <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
              <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                {{ getFormattedNumber(indicator.indikator_number) }}
              </span>
            </td>
            <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
              <!-- symbol placeholder; can be wired with env map if needed -->
              <span class="text-gray-400">Symbol</span>
            </td>
            <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
              {{ indicator.name }}
            </td>
            <td class="px-3 py-2 whitespace-nowrap">
              <div class="text-xs">
                <div class="text-gray-500">{{ indicator.room?.sektion?.gebaeude?.name || '-' }}</div>
                <div class="font-medium text-gray-900">{{ indicator.room?.sektion?.name || '-' }} - {{ indicator.room?.name || '-' }}</div>
              </div>
            </td>
            <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
              {{ indicator.indikator?.code || '' }}
            </td>
            <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
              {{ indicator.schwellenwert }}
            </td>
            <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
              {{ indicator.einheit }}
            </td>
            <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
              <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset" [ngClass]="getStatusBadgeClasses(indicator.status)">
                {{ getStatusText(indicator.status) }}
              </span>
            </td>
            <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
              <button (click)="editIndicator.emit(indicator)" class="text-blue-600 hover:text-blue-800">Bearbeiten</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="flex justify-end mt-4 mb-6" *ngIf="filtered && filtered.length > 0">
  <button (click)="printAll.emit()" class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
    <span class="mr-2">🖨️</span>
    Alle Drucken
  </button>
</div>


